import { useAuth } from '../context/AuthContext';

export const useRolePermissions = () => {
  const { userRole, user, isClient } = useAuth();

  const isAdmin = userRole === 'Admin';
  const isSuperAdmin = userRole === 'Super Admin';

  const permissions: string[] = user?.role?.permissions?.map((p: any) => p.slug) ?? [];
  const hasPermission = (slug: string) => permissions.includes(slug);

  const canViewOnly = isClient;
  const canEdit = !isClient;
  const canDelete = !isClient;
  const canCreate = !isClient;
  const canExport = isClient || isAdmin || isSuperAdmin;
  const canUpdateCustomer = isSuperAdmin || isAdmin || hasPermission('can-update-client') || hasPermission('can-update-customer');

  return {
    isClient,
    isAdmin,
    isSuperAdmin,
    canViewOnly,
    canEdit,
    canDelete,
    canCreate,
    canExport,
    canUpdateCustomer,
    hasPermission,
    currentUserId: user?._id,
    currentUserEmail: user?.email ?? null,
    userRole
  };
};